document.addEventListener('DOMContentLoaded', () => {
	if (window.csFreeItemProduct) {
		const myCartWatcher = new CartWatcher
		myCartWatcher.init()

		function updateRemoveButtonStyles(hideProductIds = []) {
			let styleTag = document.getElementById('dynamic-remove-style');
			if (!styleTag) {
				styleTag = document.createElement('style');
				styleTag.id = 'dynamic-remove-style';
				document.head.prepend(styleTag);
			}

			if (hideProductIds.length) {
				const cssRules = hideProductIds.map(id =>
					`[product-id="${id}"] cart-remove-button { display: none !important; }`
				).join('\n');

				styleTag.textContent = cssRules;
			} else {
				styleTag.textContent = '';
			}
		}

		function updateCartQuantity(id, quantity) {
			return fetch(window.Shopify.routes.root + 'cart/update.js', {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json'
				},
				body: JSON.stringify({
				updates: {
					[id]: quantity
				}
				})
			})
			.then(response => response.json())
			.then(data => {
				// console.log('Cart updated:', data);
				return data; // Optional: return cart data
			})
			.catch((error) => {
				console.error('Error updating cart:', error);
				throw error; // Optional: allow caller to catch it
			});
		}

		function newUpdateCartQuantity(id, quantity) {
			return fetch(window.Shopify.routes.root + 'cart/update.js', {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json'
				},
				body: JSON.stringify({
				updates: {
					[id]: quantity
				}
				})
			})
			.then(response => response.json())
			.then(data => {
				if (window.location.pathname === '/cart') {
					location.reload()
				} else {
					fetchCart()	
				}
			})
			.catch((error) => {
				console.error('Error updating cart:', error);
				throw error;
			});
		}

		function fetchCart() {
			const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
			const body = document.querySelector('body');

			fetch(`${routes.cart_url}?section_id=cart-drawer`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html');
					const cartDrawerContent = html.querySelector('.cart-drawer');
					const targetCartDrawer = document.querySelector('.cart-drawer');
						if (cartDrawerContent && targetCartDrawer) {
							targetCartDrawer.innerHTML = cartDrawerContent.innerHTML;
						}
						if (cart) cart.classList.remove('is-empty');
					})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					if (cart) cart.classList.add('animate', 'active');
					if (body) body.classList.add('overflow-hidden');
				});

			fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html');
					const cartIconBubble = html.querySelector('.shopify-section');
					const targetIconBubble = document.querySelector('#cart-icon-bubble');
					if (cartIconBubble && targetIconBubble) {
						targetIconBubble.innerHTML = cartIconBubble.innerHTML;
					}
				})
				.catch((e) => {
					console.error(e);
				});
		}

		document.addEventListener("cart_changed", e => {
			fetch('/cart.json')
			.then(response => response.json())
			.then(cartData => {

				const targetId = window.csFreeItemProduct
				// console.log(cartData.items)

				const bundleDeals = document.querySelector('bundle-deals')

				if (bundleDeals) {
					const cartItems = cartData.items

					const matchingId = cartItems.find(item => item.variant_id === targetId);
					const variantId = matchingId ? matchingId.variant_id : null;

					const matchProductIdFree = cartItems.find(item => item.variant_id === targetId);
					const conProductQtyFree = matchProductIdFree ? matchProductIdFree.quantity : 0;

					const contProductId1 = Number(bundleDeals.querySelectorAll('.upsell')[0].getAttribute('data-id'))

					const matchProductId1 = cartItems.find(item => item.variant_id === contProductId1);
					const conProductQty1 = matchProductId1 ? matchProductId1.quantity : 0;

					const contProductId2 = Number(bundleDeals.querySelectorAll('.upsell')[1].getAttribute('data-id'))

					const matchProductId2 = cartItems.find(item => item.variant_id === contProductId2);
					const conProductQty2 = matchProductId2 ? matchProductId2.quantity : 0;

					if (conProductQty1 == 0) {
						if (variantId) {
							// console.log(`conProductQty1 Variant ID found ${variantId}`)
							updateCartQuantity(variantId, 0)
							.then(() => {
								fetchCart();
							})
							.catch(error => {
								console.error('Something went wrong:', error);
							});
						}
					} else if (conProductQty2 == 0) {
						if (variantId) {
							// console.log(`conProductQty2 Variant ID found ${variantId}`)
							updateCartQuantity(variantId, 0)
							.then(() => {
								fetchCart();
							})
							.catch(error => {
								console.error('Something went wrong:', error);
							});
						}
					} else if (conProductQty1 == conProductQty2 && conProductQtyFree > conProductQty1) {
						// console.log(`Variant ID found ${variantId}`)
						updateCartQuantity(variantId, conProductQty1)
						.then(() => {
							fetchCart();
						})
						.catch(error => {
							console.error('Something went wrong:', error);
						});
					}

					const hasTargetProduct = cartItems.some(item => item.product_id === targetId)
					if (hasTargetProduct) {
						// console.log('has item')
						const otherProductIds = cartItems
							.filter(item => item.product_id !== targetId)
							.map(item => item.id);
						updateRemoveButtonStyles(otherProductIds);
					} else {
						// console.log('has no item')
						updateRemoveButtonStyles()
					}
				}				

				if (window.addonProductId) {
					console.log('PRODUCT ADDON PRESENT')
					initAddonCartWatcher()
					function initAddonCartWatcher() {						
						document.addEventListener("cart_changed", e => {
							fetch('/cart.json')
							.then(response => response.json())
							.then(initcart => {														
								const cartItems = initcart.items
								const personalizedItems = cartItems.filter(item =>
									item.properties && item.properties.personalized_text
								)
								const personalizedItemsQuantity = personalizedItems.reduce((sum, item) => sum + item.quantity, 0)
								const selectAddon = cartItems.filter(item => item.id == window.addonProductId)
								const selectAddonQuantity = selectAddon.reduce((sum, item) => sum + item.quantity, 0)

								if (selectAddonQuantity > 0 && selectAddonQuantity == personalizedItemsQuantity) {													
									console.log('QUANTITIES MATCH')
								} else if (selectAddonQuantity > 0 && personalizedItemsQuantity >= 0) {
									console.log('QUANTITIES DO NOT MATCH')
									newUpdateCartQuantity(window.addonProductId, personalizedItemsQuantity)
								}

							})
							.catch(error => console.error('Error fetching cart data:', error))
						})
					}
				} else {
					console.log('PRODUCT ADDON NOT PRESENT')
				}

			})
			.catch(error => console.error('Error fetching cart data:', error))
		})
	}
})